<div class="ui-g">
  <div class="ui-g-12">
    <div class="ui-g-12">
      <div style="display: flex;" class="mobile-view-translate">
        <div>
          <h2 class="heading3 nameHeading notranslate">
            Welcome, {{ userName }}
            <span *ngIf="this.isuserregnumber" class="dashregno notranslate">Reg No. : {{ this.actualuserregnumber
              }}</span>
          </h2>
          <h2 class="heading4 titleStyle marginbttom">
            How are you feeling today?
          </h2>
        </div>
        <div
          style="display: flex;;align-items: center; justify-content: end;;margin-left: auto;margin-right: 50px;font-size: 17px;font-weight: bold;">
          <p>Choose Language : </p>
          <div class="mt-3 mr-3">
            <select class="notranslate customize-dropdown" style="width: 150px;font-size: 17px;"
              [(ngModel)]="selectedLanguage" (change)="translatePage($event)">
              <option *ngFor="let option of languageOptions" [value]="option.code">
                {{ option.name }}
              </option>
            </select>
          </div>

          <!-- <div id="google_translate_element" style="display: none;"></div> -->
        </div>
      </div>
      <div class="ui-g dashboard-center">
        <div class="ui-g-12 ui-lg-12" *ngIf="!(this.appointmentsList.length == 0)">
          <h2 class="heading4 titleStyle text-align-center">Message Center</h2>
          <div class="ui-g-12 height89">
            <div class="borderStyle">
              <div id="scrollStyle">
                <p-tabView>
                  <p-tabPanel [headerStyle]="{ width: '49%', height: '61px' }">
                    <ng-template pTemplate="header">
                      <span class="whitesp">Upcoming Appointments</span>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <div *ngFor="let appointment of appointmentsList" class="ui-g-12 notification-list-item">
                        <div class="ui-g-12">
                          <div class="ui-g-3">
                            <img src="{{ appointment.doctorPhoto }}" class="img-doctor" />
                          </div>
                          <div class="ui-g-3 notranslate">
                            {{ appointment.doctorname }}
                          </div>
                          <div class="ui-g-3 notranslate">
                            {{
                            appointment.appointmentdate
                            | date: 'MMMM d, h:mm a'
                            }}
                          </div>
                          <div class="ui-g-3">
                            <a [ngClass]="{
                                'disabled-link': !(
                                  appointment.zoomlink.length > 0
                                )
                              }" href="{{ appointment.zoomlink }}" target="_blank" rel="noopener noreferrer">
                              <p-button [disabled]="!(appointment.zoomlink.length > 0)" type="button" label="Join Now"
                                class="dashbutton cardmargin">
                              </p-button>
                            </a>
                          </div>
                        </div>
                        <div style="text-align: center">
                          <span style="color: green"><b>Note: </b></span>Join
                          Zoom button will be enabled 15 minutes before and
                          after appointment time
                        </div>
                      </div>
                      <div *ngIf="appointmentsList.length == 0" class="ui-g-12 notification-list-item empty-section">
                        No Upcoming Appointments
                      </div>
                    </ng-template>
                  </p-tabPanel>
                  <p-tabPanel [headerStyle]="{ width: '49%', height: '61px' }">
                    <ng-template pTemplate="header">
                      <span>Message
                        <div class="msgStyle">
                          &nbsp; {{ count }} &nbsp;
                        </div>
                      </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <div *ngFor="let message of messageList" class="ui-g-12 notification-list-item">
                        <div class="ui-g-12">
                          <div class="ui-g-12">
                            <div class="ui-g-6">
                              {{
                              message.messages.egd_users.first_name +
                              '
                              ' +
                              (message.messages.egd_users.middle_name==null?'':message.messages.egd_users.middle_name) +
                              '
                              ' +
                              message.messages.egd_users.last_name
                              }}
                            </div>
                            <div class="ui-g-6">
                              {{
                              message.messages.created_at
                              | date: 'MMMM d,h:mm a'
                              }}
                            </div>
                          </div>
                          <div class="ui-g-12">
                            <div class="ui-g-6">
                              {{ message.messages.subject }}
                            </div>
                            <div class="ui-g-6">
                              <button pButton type="button"
                                [routerLink]="['/', this.slug, 'patient', 'mailview', message.patient_guid, message.messages.id, message.messages.user_guid, 'false']"
                                label="View" class="dashbutton cardmargin"></button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="messageList.length == 0" class="ui-g-12 notification-list-item empty-section">
                        No Messages
                      </div>
                    </ng-template>
                  </p-tabPanel>
                </p-tabView>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="ui-g-12" *ngIf="!this.isIndia">
          <div class="ui-g">
              <img routerLink="../consultdoctor" class="homeImg"
                  src="./assets/images/dashboard/patient/dashboarad_consult_now banner.png" alt="Book Consultation"
                  style="width:90%">
          </div>
      </div>
      <div class="ui-g-12" *ngIf="this.isIndia">
          <div class="ui-g">
              <img routerLink="../consultdoctor" class="homeImg"
                  src="./assets/images/dashboard/patient/Thursday_offer_banner_dashboard.png" style="width:90%"
                  alt="Book Consultation">
          </div>
      </div> -->
    <div class="ui-g-12" *ngIf="!isUK && this.is_primary_provider">
      <div class="ui-g">
        <p-carousel [value]="this.isIndia ? carouselItemsIndia : carouselItemsUSA" [numVisible]="1" [numScroll]="1"
          [autoplayInterval]="5000" styleClass="custom-carousel">
          <ng-template let-item pTemplate="content">
            <img [src]="item.image" alt="{{ item.alt }}" (click)="this.RouterNavigation(item.click)"
              (touchend)="this.RouterNavigation(item.click)" style="width: 100%" />
          </ng-template>
        </p-carousel>
      </div>
    </div>

    <div class="ui-g-12"></div>
    <div class="ui-g-12"></div>
    <h2 class="heading3 egd-color titled">Consultation Types</h2>
    <br />
    <div class="ui-g-12" style="background-color: gainsboro">
      <div class="ui-g">
        <ng-container>
          <div class="ui-g-12">
            <div class="ui-g">
              <div class="ui-g-12 ui-md-3 fourcards" style="background-color: white"
                *ngFor="let cons of consultationList">
                <img [src]="cons.consultation_type.consultation_image" [alt]="cons.consultation_type.consultation_name"
                  class="consultationtypeimg" alt="Card image" />
                <div class="card-body">
                  <h4 class="card-title commontxt" style="height: 20px">
                    {{ cons.consultation_type.consultation_name }}
                  </h4>

                  <div class="amount-button-container" style="padding-top: 50px">
                    <p class="amount notranslate" style="font-weight: 900">
                      {{ cons['renderedAmount'] }}
                    </p>
                    <button pButton type="button" label="Consult Now" [routerLink]="['../','consultdoctor']"
                      [queryParams]="{
                        consultation_type_id: cons.consultation_type_id
                      }" class="dashbutton cardmargin"></button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="ui-g-12"></div>
    <div class="ui-g-12"></div>
    <h2 class="heading3 egd-color titled">Common Health Issues</h2>

    <div #focusfield>
      <div *ngIf="display">
        <div class="ui-g-12">
          <div class="ui-g" style="background-color: gainsboro; padding: 15px">
            <div class="two-d-card-commonissues fivecards ui-g-12" style="background-color: white"
              *ngFor="let commonissue of commonissues">
              <img src="{{ commonissue.health_issue_image }}" class="commonhealthimg" alt="Card image" />
              <div class="card-body1">
                <h4 class="card-title commontxt1">{{ commonissue.title }}</h4>
              </div>
              <button pButton type="button" style="margin-bottom: 10px" label="Consult Now"
                [routerLink]="['../', 'consultdoctor']" [queryParams]="{ common_health_id: commonissue.id }"
                class="dashbutton cardmargin"></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-align-center">
      <button pButton type="button" (click)="display = !display; focusfield.scrollIntoView()"
        [label]="display ? 'Show Less' : 'Load More'" class="dashbutton cardmargin commonhealthbtn notranslate"
        role="button"></button>
    </div>
    <!-- <div *ngIf="this.dietPrice.length > 0 && this.is_primary_provider">
      <div class="ui-g-12 buttonbottom margin-bottom-dashboard">
        <div class="freedietplan">
          <div class="ui-g-12 packages-dashboard-main"> -->
    <!-- <img src="./assets/images/dashboard/patient/Get2consultations.png" id="get2consultation" alt=""
                srcset=""> -->
    <!-- <h2 class="consultation-free egd-color text-align-center">
              Get a Diet Consultation for FREE
            </h2>
            <p class="free-plan-desc text-align-center">
              Fill this form to get a <b class="egd-color">FREE</b> diet
              assessment worth <b class="egd-color notranslate"> {{ freeDietPrice }}</b> from
              our Expert Nutrition Coaches.
            </p>
          </div> -->
    <!-- <button
            class="bookplanbutton ui-md-9"
            routerLink="../consultdoctor"
            [queryParams]="{ consultation_type_id: 5 }"
          >
            Book Now
          </button> -->
    <!-- <button pButton type="button" [routerLink]="['../', 'consultdoctor']" [queryParams]="{ consultation_type_id: 5 }"
            label="Book Now" class="dashbutton cardmargin explore-plan-btn" role="button"></button>
        </div>
      </div> -->
    <!-- <div class="display-flex-dietplans ui-g-12">
        <div class="priceofdietplan">
          <img class="dietconsultationimage" src="./assets/images/dashboard/patient/BlueaGradientBox.png"
            alt="Diet Consultation" />
          <h2 class="heading3 pricedisplay titled margin-bottom-dashboard">
            {{ dietPrice[0] }}
          </h2>
          <button pButton type="button" routerLink="../consultdoctor" [queryParams]="{ consultation_type_id: 5 }"
            label="Book Now" class="explore-plan-btn bookplanbuttonweeks dashbutton cardmargin" role="button"></button>
        </div>
        <div class="priceofdietplan">
          <img class="dietconsultationimage" src="./assets/images/dashboard/patient/RedGradientBox.png"
            alt="Diet Consultation " />
          <h2 class="heading2 pricedisplay titled margin-bottom-dashboard">
            {{ dietPrice[1] }}
          </h2>
          <button pButton type="button" routerLink="../consultdoctor" [queryParams]="{ consultation_type_id: 5 }"
            label="Book Now" class="explore-plan-btn bookplanbuttonweeks dashbutton cardmargin" role="button"></button>
        </div>
      </div> -->
    <!-- </div> -->

    <!-- Travelling to USA banner -->
    <!-- <div class="ui-g-12">
          <div class="ui-g-12 text-center">
              <img routerLink="../packages"
                  src="./assets/images/dashboard/patient/Health care package banner_White_bg.png" alt="Notebook"
                  class="homeImg" style="width:70%">
          </div>
      </div> -->
    <div class="ui-g-12" class="packages" *ngIf="this.is_primary_provider && !this.is_uk_country">
      <div class="ui-g-12 text-center">
        <h2 class="heading3 egd-color titled">
          Worried about your Medical Needs <span *ngIf="!isUK">in USA</span>? <br />
          Check Out Our Health Packages
        </h2>
      </div>
      <div class="ui-g-12 packages-dashboard-main">
        <div class="packages-image">
          <img class="package-Img" src="./assets/images/dashboard/patient/Our_health_package_image.png"
            alt="Diet Consultation" />
        </div>
        <div class="package-content">
          <h2 class="heading3 egd-color">
            Benefits of having a Health Package
          </h2>
          <p class="heading4">
            Introducing package deals for you and your family members.<br />Now
            get yourself consulted at lower cost
          </p>
          <ul>
            <li class="heading4 card-li-txt">
              Choose from our board certified doctors<span *ngIf="!this.is_uk_country">(USA and India).</span>
            </li>
            <li class="heading4 card-li-txt">Prescription will be provided.</li>
            <li class="heading4 card-li-txt">
              Our Specialties<a class="egd-color show_click" target="viewAllSpecialties" (click)="
                  openLink(
                    'HOMPAGE_BASE_URL',
                    'view-specialties',
                    'eGlobalDoctors-View-All-specialties'
                  )
                ">
                  (View Specialties)
                </a>
              </li>
              <li class="heading4 card-li-txt">
                Video Consultation upto 30 mins.
              </li>
              <li class="heading4 card-li-txt">
                This packages can be used by yourself or your family members.
              </li>
              <li class="heading4 card-li-txt">Response time 1-3 days.</li>
            </ul>
            <div class="text-align-center">
              <div class="text-align-center">
                <button pButton type="button" [routerLink]="['../', 'packages']" label="Explore Plans"
                  class="dashbutton cardmargin explore-plan-btn" role="button"></button>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="text-align-center">
            <button pButton type="button" (click)="show = !show" [label]="show ? 'Show less' : 'View Features'"
              class="dashbutton cardmargin view-feature-btn" role="button"></button>
          </div>
          <!-- <div class="container" *ngIf="show"> -->
          <div class="ui-g-12" *ngIf="show">
            <div class="card two-d-card mr-auto ml-auto mt-5">
              <div class="card-body">
                <h5 class="card-title egd-color font-weight-bolder ml-1 heading2" style="margin: 10px">
                  Features
                </h5>

              <div class="card-text">
                <ul class="font-weight-bold">
                  <li class="card-li-txt heading5">
                    <span *ngIf="this.is_uk_country">Access to GMC registered UK specialist doctors.</span>
                    <span *ngIf="!this.is_uk_country">Access to doctors from USA, UK, India and other parts of the
                      world</span>
                    <span style="white-space: nowrap">
                      <a class="egd-color show_click" target="viewAllDoctors" (click)="
                          openLink(
                            'HOMPAGE_BASE_URL',
                            'view-doctors',
                            'eGlobalDoctors-View-All-Doctors'
                          )
                        ">
                        <span *ngIf="this.is_primary_provider">(View Doctors)</span>
                      </a>
                      <i class="fa fa-arrow-left arrowfeatures heading3 alert alert-danger" aria-hidden="true" *ngIf="!this.is_uk_country"></i>
                    </span>
                  </li>
                  <li class="card-li-txt heading5">
                    Our Specialties - Internal Medicine, Cardiology,
                    Orthopedics, Oncology, Pediatrics, Psychiatry and many more.
                    <span style="white-space: nowrap">
                      <a class="egd-color show_click" target="viewAllSpecialties" (click)="
                          openLink(
                            'HOMPAGE_BASE_URL',
                            'view-specialties',
                            'eGlobalDoctors-View-All-specialties'
                          )
                        ">
                        <span *ngIf="this.is_primary_provider">(View Specialties)</span>
                      </a>
                      <i class="fa fa-arrow-left arrowfeatures heading3 alert alert-danger" aria-hidden="true" *ngIf="!this.is_uk_country"></i>
                    </span>
                  </li>
                  <li class="card-li-txt heading5">
                    Prescription will be provided.
                  </li>
                  <li class="card-li-txt heading5">
                    Response time 1 - 3 days.
                  </li>

                    <li class="card-li-txt heading5">
                      Family Members can participate live via Video Physician
                      Consultation from any part of the world.
                    </li>
                    <li class="card-li-txt heading5">
                      Video Consultation upto 30 minutes.
                    </li>

                  <li class="card-li-txt heading5">
                    No restrictions on pre existing medical conditions.
                  </li>
                  <li class="card-li-txt heading5">
                    In-app messaging with doctor after consultation.
                  </li>
                  <li class="card-li-txt heading5">
                    ID and Portable Health Passports.
                  </li>
                  <li class="card-li-txt heading5">
                    These packages are applicable only for Primary Consultations
                    and <span *ngIf="!this.is_uk_country">Expert Second Medical Opinion.</span><span
                      *ngIf="!this.is_uk_country">Specialist Consultation</span>
                  </li>
                  <li class="card-li-txt heading5">
                    Package subscription can be extended; it cannot be canceled.
                  </li>
                  <li class="card-li-txt heading5">
                    If the subscribed package is not used in 6 months from the
                    date of purchase; subscription can be extended to one year.
                  </li>
                  <li class="card-li-txt heading5">
                    The numbers are subject to change under the authority of
                    eGlobalDoctors.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>

      <!-- <div class="ui-g-12">
          <div class="text-align-center">
              <button pButton type="button" (click)="showDiet = !showDiet"
                  [label]="showDiet ? 'Show less': 'Learn more'" class="dashbutton cardmargin commonhealthbtn"
                  role="button">
              </button>
          </div>
         
          <div class="ui-g-12" *ngIf="showDiet">
              <div class="card two-d-card mr-auto ml-auto mt-5">
                  <div class="card-body">
                      <h5 class="card-title egd-color font-weight-bolder ml-1 heading2" style="margin:10px;">
                          Features
                      </h5>
                      <div class="card-text">
                          <ul class="font-weight-bold">
                              <li class="card-li-txt heading5">
                                  Access to doctors from USA, UK, India and other parts of the world
                                  <a class="egd-color show_click" target="viewAllDoctors"
                                      (click)="openLink('HOMPAGE_BASE_URL','view-doctors', 'eGlobalDoctors-View-All-Doctors')">
                                      (View Doctors)
                                  </a>
                                  <i class="fa fa-arrow-left arrowfeatures heading3 alert alert-danger"
                                      aria-hidden="true"></i>
                              </li>
                              <li class="card-li-txt heading5">
                                  Our Specialties - Internal Medicine, Cardiology, Orthopedics, Oncology,
                                  Pediatrics, Psychiatry and many more.
                                  <a class="egd-color show_click" target="viewAllSpecialties"
                                      (click)="openLink('HOMPAGE_BASE_URL','view-specialties', 'eGlobalDoctors-View-All-specialties')">
                                      (View Specialties)
                                  </a>
                                  <i class="fa fa-arrow-left arrowfeatures heading3 alert alert-danger"
                                      aria-hidden="true"></i>
                              </li>
                              <li class="card-li-txt heading5">
                                  Prescription will be provided.
                              </li>
                              <li class="card-li-txt heading5">
                                  Response time 1 - 3 days.
                              </li>

                              <li class="card-li-txt heading5">
                                  Family Members can participate live via Video Physician Consultation
                                  from any part of the world.
                              </li>
                              <li class="card-li-txt heading5">
                                  Video Consultation upto 30 minutes.
                              </li>
                              <li class="card-li-txt heading5">
                                  No restrictions on pre existing medical conditions.
                              </li>
                              <li class="card-li-txt heading5">
                                  In-app messaging with doctor after consultation.
                              </li>
                              <li class="card-li-txt heading5">
                                  ID and Portable Health Passports.
                              </li>
                              <li class="card-li-txt heading5">
                                  These packages are applicable only for Primary Consultations and Expert
                                  Second Medical Opinion.
                              </li>
                              <li class="card-li-txt heading5">
                                  Package subscription can be extended; it cannot be canceled.
                              </li>
                              <li class="card-li-txt heading5">
                                  If the subscribed package is not used in 6 months from the date of
                                  purchase;
                                  subscription can be extended to one year.
                              </li>
                              <li class="card-li-txt heading5">
                                  The numbers are subject to change under the authority of eGlobalDoctors.
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div> -->

      <!-- </div> -->

      <!-- Packages section -->

      <!-- Packages section -->
      <!-- <div class="ui-g-12">
          <div class="ui-g-12 text-center">
              <img routerLink="/patient/nutrition-and-health" class="homeImg"
                  src="./assets/images/dashboard/patient/DietBanner.png" alt="Diet Consultation" style="width:90%">
          </div>
      </div> -->
      <div class="ui-g-12"></div>

      <!-- <div class="diet">
      <button class="dashbutton cardmargin" >Explore More</button>
  </div> -->

    </div>
    <div class="ui-g-12" *ngIf="this.is_primary_provider">
      <div class="ui-g-12 text-center">
        <h2 class="heading3 titled">
          <span class="egd-color">Our <span class="notranslate"> 24×7</span> support team is here to help you
            anytime</span><br>
          <span>
            <b class="notranslate">
<<<<<<< HEAD
              <a style="color: black;" href="tel:+44 213-406-7898">{{ this.phoneNumber }} </a><br>
              <!-- <a style="color: black;" [href]="'tel:+44 213-406-7898'">{{ phonenumberlist[1] + '(' + (isUK ? 'UK' : 'USA') + ')'}}</a> -->
=======
              <a style="color: black;" href="tel:+91 207-119-0009" *ngIf="isIndia">{{ phonenumberlist[0] }}(India)
              </a><br>
              <a style="color: black;" [href]="'tel:' + phonenumberlist[1]">{{ phonenumberlist[1] + '(' + (isUK ? 'UK' :
                'USA') + ')'}}</a>
>>>>>>> 02f26c93645f4172e2fee9fbaf66f8d290ab5706
            </b> </span>
        </h2>
      </div>
    </div>
  </div>
</div>